export default __webpack_public_path__ + "static/media/07.091a9566.jpg";